// Counterpart of webapp/src/store/comments.ts

import {create} from 'zustand'
import {Block} from '../types/block'
import client from '../api/client'

export type CommentBlock = Block & {type: 'comment'}

const asComment = (block: Block): CommentBlock => ({...block, type: 'comment'}) as CommentBlock

type CommentsState = {
    comments: Record<string, CommentBlock>
    loadBoardComments: (boardId: string) => Promise<CommentBlock[]>
    upsertComments: (comments: CommentBlock[]) => void
    upsertComment: (comment: CommentBlock) => void
    removeComment: (commentId: string) => void
}

export const useComments = create<CommentsState>((set, get) => ({
    comments: {},

    async loadBoardComments(boardId) {
        const blocks = await client.getBlocksWithType('comment')
        const comments = blocks.filter((b) => b.boardId === boardId).map(asComment)
        get().upsertComments(comments)
        return comments
    },

    upsertComments(comments) {
        set((state) => {
            const next = {...state.comments}
            comments.forEach((c) => {
                if (c.deleteAt === 0) {
                    next[c.id] = c
                } else {
                    delete next[c.id]
                }
            })
            return {comments: next}
        })
    },

    upsertComment(comment) {
        get().upsertComments([comment])
    },

    removeComment(commentId) {
        set((state) => {
            const comments = {...state.comments}
            delete comments[commentId]
            return {comments}
        })
    },
}))

export function selectCommentsOfCard(state: CommentsState, cardId: string | undefined): CommentBlock[] {
    if (!cardId) {
        return []
    }
    return Object.values(state.comments).
        filter((c) => c.parentId === cardId && c.deleteAt === 0).
        sort((a, b) => a.createAt - b.createAt)
}
